
export const DownloadFunctionality = ({ arrayHref }: any) => {
  return (
    <div className="flex flex-col gap-4 items-center px-4">
      {arrayHref.map((item: any) => (
        <a
          href={item.href}
          target="_blank"
          rel="noopener noreferrer"
          className="hover:cursor-pointer hover:scale-105 transition-all duration-300 active:scale-100"
        >
          <img
            src={item.src}
            alt={item.alt}
            className="w-40 h-auto"
          />
        </a>
      ))}
    </div>
  );
};
